import { gql } from '@apollo/client';

// Fragment-only module, with no component or heavy-library imports, so the global
// fragment registry can register these fragments without pulling the calendar event
// helpers, and react-big-calendar with them, into the boot-time entry chunk.

export const SCHEDULE_SHIFT_FRAGMENT = gql`
    fragment ScheduleShift on ShiftOccurrence {
        id
        startDatetime
        endDatetime
        clinician {
            id
            timezone
        }
        isCanceled
        recurrence {
            id
            dropReason
            serviceLimits {
                id
                service {
                    id
                }
                maxLimit
            }
        }
    }
`;

export const SCHEDULE_SHIFT_BLOCK_FRAGMENT = gql`
    fragment ScheduleShiftBlock on ShiftBlockOccurrence {
        id
        startDatetime
        endDatetime
        clinician {
            id
            firstName
            lastName
        }
        recurrence {
            id
            notes
            numAllClinicians
        }
    }
`;

export const SCHEDULE_TENTATIVE_SHIFT_BLOCK_FRAGMENT = gql`
    fragment ScheduleTentativeShiftBlock on TentativeShiftBlockOccurrence {
        id
        startDatetime
        endDatetime
        parentRequest {
            id
            requestingClinician {
                id
            }
            notes
        }
    }
`;

export const SCHEDULE_CLINICIAN_APPOINTMENT_FRAGMENT = gql`
    fragment ScheduleClinicianAppointment on ClinicianAppointment {
        id
        startDatetime
        endDatetime
        clinician {
            id
        }
        visit {
            id
            patient {
                id
                fullName
            }
        }
        encounters {
            id
            service {
                id
                name
            }
        }
    }
`;

export const SCHEDULE_VISIT_CHIP_FRAGMENT = gql`
    fragment ScheduleVisitChip on ClinicianAppointment {
        id
        visit {
            id
            notesForClinician
            address {
                ...BasicAddress
            }
        }
    }
`;

export const SCHEDULE_CLINICIAN_RESERVATION_FRAGMENT = gql`
    fragment ScheduleClinicianReservation on ClinicianReservation {
        id
        clinician {
            id
            firstName
            lastName
        }
        startOffsetMinutes
        durationMinutes
        isVirtual
        startDatetime
        endDatetime
        services @include(if: $hasReservationsFlow) {
            id
            name
        }
        visitReservation {
            id
            organization {
                id
            }
            externalId
            patientName @include(if: $hasReservationsFlow)
            patientPhoneNumber @include(if: $hasReservationsFlow)
            startDatetime
            expiryDatetime
            address {
                id
                address1
                address2
                city
                state
                zipcode
            }
            zipCode
            isFulfilled
        }
    }
`;

export const TENTATIVE_CLINICIAN_APPOINTMENT_FRAGMENT = gql`
    fragment TentativeClinicianAppointment on ClinicianAppointment {
        id
        durationMinutes
        startOffsetMinutes
        visit {
            id
            patient {
                id
                fullName
            }
        }
        encounters {
            id
            service {
                id
                name
            }
        }
    }
`;

export const SCHEDULE_CLINICIAN_FRAGMENT = gql`
    fragment ScheduleClinician on Clinician {
        id
        firstName
        lastName
        timezone
        logoUrl
        isActive
    }
`;

export const SCHEDULE_UNSCHEDULED_VISIT_FRAGMENT = gql`
    fragment ScheduleUnscheduledVisit on Visit {
        id
        effectiveDate
        clinicianAppointments {
            id
            clinician {
                id
                fullName
            }
            services {
                id
                name
            }
            visit {
                id
                patient {
                    id
                    fullName
                }
            }
        }
    }
`;
